module.exports = __webpack_public_path__ + "static/media/logo-mon-test-auditif-noir.6637fabe.png";